import { render, staticRenderFns } from "./BAutocompleteParticipants.vue?vue&type=template&id=5aabd5ae&"
import script from "./BAutocompleteParticipants.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports